/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/adv-frontend-filters/keyset/filters%2FcreateFilterInput%2Fvalidate%2FvalidateNotEmpty.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    'Необходимо указать значение': {
        ru: 'Выберите хотя\u00A0бы одно значение',
        en: 'Select at\u00A0least one value',
        'en-IE': 'You must specify the value',
        tr: 'En az bir değer seçin',
        'zh-Hans': '请输入一个值',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
